var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('combobox', {
    ref: "primaryInput",
    staticClass: "product-category-combobox",
    attrs: {
      "disabled": _vm.disabled,
      "errors": _vm.internalErrors,
      "internal-search": false,
      "is-loading": _vm.isLoading,
      "label": _vm.label,
      "multiple": _vm.multiple,
      "options": _vm.options,
      "placeholder": _vm.placeholder,
      "value": _vm.internalValue
    },
    on: {
      "close": _vm.onClose,
      "input": _vm.onInput,
      "search": _vm.onSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option) ? _c('product-category-hierarchy', {
          attrs: {
            "category": props.option
          }
        }) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "singleLabel"
  }, [_c('product-category-hierarchy', {
    attrs: {
      "category": _vm.internalValue
    },
    slot: "singleLabel"
  })], 1)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16227502","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductCategoryCombobox.vue
// module id = 1873
// module chunks = 0